import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPosts } from '../services/blogApi';

const N  = '#0A2540';
const E  = '#7C4DFF';
const ED = '#6030E8';

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getPosts(page, 9)
      .then(res => {
        const data = res.data;
        setPosts(data.content || data);
        setTotalPages(data.totalPages || 1);
      })
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <div style={{ minHeight: '100vh', background: '#F5F7FA' }}>
      {/* Hero */}
      <div style={{
        background: `linear-gradient(135deg, ${N} 0%, #0D3060 55%, #003828 100%)`,
        padding: '140px 24px 80px',
        textAlign: 'center',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'radial-gradient(rgba(124,77,255,0.04) 1px, transparent 1px)',
          backgroundSize: '40px 40px', pointerEvents: 'none',
        }} />
        <div style={{
          display: 'inline-block', background: 'rgba(124,77,255,0.15)',
          color: E, padding: '4px 14px', borderRadius: 20,
          fontSize: '0.82rem', fontWeight: 700, marginBottom: 16,
          border: '1px solid rgba(124,77,255,0.35)',
        }}>
          INSIGHTS & PERSPECTIVES
        </div>
        <h1 style={{
          fontFamily: "'Poppins', sans-serif", fontWeight: 800,
          fontSize: 'clamp(2rem, 4vw, 3rem)', color: '#fff', marginBottom: 16,
          position: 'relative',
        }}>
          Dennis's <span style={{ color: E }}>Blog</span>
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.58)', maxWidth: 500, margin: '0 auto', position: 'relative' }}>
          Articles on digital finance, development consulting, and inclusive economic growth in Africa.
        </p>
      </div>

      {/* Posts grid */}
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '60px 24px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0', color: E }}>
            <i className="fas fa-spinner fa-spin" style={{ fontSize: '2.5rem' }} />
          </div>
        ) : posts.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '80px 0' }}>
            <div style={{ fontSize: '4rem', marginBottom: 16 }}>📝</div>
            <h3 style={{ color: N, marginBottom: 8 }}>No posts yet</h3>
            <p style={{ color: '#718096' }}>Check back soon for articles and insights.</p>
          </div>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 28 }} className="blog-grid">
              {posts.map(post => (
                <Link key={post.id} to={`/blog/${post.id}`} style={{
                  textDecoration: 'none', background: '#fff', borderRadius: 14,
                  border: '1px solid #E2E8F0', overflow: 'hidden',
                  boxShadow: '0 2px 12px rgba(10,37,64,0.07)', transition: 'all 0.3s',
                  display: 'flex', flexDirection: 'column',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 12px 30px rgba(124,77,255,0.16)';
                    e.currentTarget.style.borderColor = E;
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = 'none';
                    e.currentTarget.style.boxShadow = '0 2px 12px rgba(10,37,64,0.07)';
                    e.currentTarget.style.borderColor = '#E2E8F0';
                  }}
                >
                  {post.coverImageUrl ? (
                    <img src={post.coverImageUrl} alt={post.title}
                      style={{ width: '100%', height: 200, objectFit: 'cover' }} />
                  ) : (
                    <div style={{
                      height: 200,
                      background: `linear-gradient(135deg, ${N} 0%, #0D3060 60%, #003828 100%)`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      <i className="fas fa-book-open" style={{ color: 'rgba(255,255,255,0.22)', fontSize: '3rem' }} />
                    </div>
                  )}
                  <div style={{ padding: 22, flex: 1, display: 'flex', flexDirection: 'column' }}>
                    {post.category && (
                      <span style={{
                        background: 'rgba(124,77,255,0.10)', color: ED,
                        fontSize: '0.73rem', fontWeight: 700, padding: '3px 10px', borderRadius: 20,
                        alignSelf: 'flex-start', marginBottom: 10,
                        border: '1px solid rgba(124,77,255,0.25)',
                      }}>
                        {post.category}
                      </span>
                    )}
                    <h3 style={{ color: N, fontSize: '1rem', fontWeight: 700, lineHeight: 1.4, marginBottom: 10, flex: 1 }}>
                      {post.title}
                    </h3>
                    {post.excerpt && (
                      <p style={{ color: '#718096', fontSize: '0.85rem', lineHeight: 1.6, marginBottom: 14 }}>
                        {post.excerpt.substring(0, 110)}...
                      </p>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto', paddingTop: 14, borderTop: '1px solid #F0F4F8' }}>
                      <span style={{ color: '#718096', fontSize: '0.78rem' }}>
                        <i className="fas fa-calendar" style={{ marginRight: 5, color: E }} />
                        {post.publishedAt ? new Date(post.publishedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : 'Draft'}
                      </span>
                      <span style={{ color: ED, fontSize: '0.82rem', fontWeight: 600 }}>
                        Read more <i className="fas fa-arrow-right" />
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 48 }}>
                <button onClick={() => setPage(p => Math.max(0, p - 1))} disabled={page === 0}
                  style={{
                    padding: '8px 16px', borderRadius: 8, border: '1px solid #E2E8F0',
                    background: page === 0 ? '#F5F7FA' : '#fff',
                    cursor: page === 0 ? 'not-allowed' : 'pointer',
                    color: page === 0 ? '#CBD5E0' : N, fontFamily: 'inherit',
                  }}>
                  ← Prev
                </button>
                {Array.from({ length: totalPages }, (_, i) => (
                  <button key={i} onClick={() => setPage(i)}
                    style={{
                      width: 36, height: 36, borderRadius: 8,
                      border: `1px solid ${page === i ? E : '#E2E8F0'}`,
                      background: page === i ? E : '#fff',
                      color: page === i ? '#fff' : N,
                      cursor: 'pointer', fontWeight: page === i ? 700 : 400,
                      fontFamily: 'inherit',
                    }}>
                    {i + 1}
                  </button>
                ))}
                <button onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))} disabled={page === totalPages - 1}
                  style={{
                    padding: '8px 16px', borderRadius: 8, border: '1px solid #E2E8F0',
                    background: page === totalPages - 1 ? '#F5F7FA' : '#fff',
                    cursor: page === totalPages - 1 ? 'not-allowed' : 'pointer',
                    color: page === totalPages - 1 ? '#CBD5E0' : N, fontFamily: 'inherit',
                  }}>
                  Next →
                </button>
              </div>
            )}
          </>
        )}
      </div>

      <style>{`
        @media (max-width: 992px) { .blog-grid { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 600px)  { .blog-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </div>
  );
}
